<template>
  <div>
    <v-form ref="regform" v-model="formValid" spellcheck="false">
      <v-row>
        <v-col
          v-if="
            barcodeField.id &&
              this.$store.getters['config/shouldFillQRCodeField']
          "
          cols="12"
        >
          <v-text-field
            v-model="models[barcodeField.id]"
            :rules="rules[barcodeField.id]"
            :type="barcodeField.type"
            validate-on-blur
            required
            :loading="validatingBarcodeLoader"
            @blur="validateBarcode()"
            :success-messages="validatingBarcodeSuccessMessage"
            :error-messages="validatingBarcodeErrorMessage"
            :messages="validatingBarcodeLoadingMessage"
            :append-icon="validatingBarcodeLoadingIcon"
          >
            <template #label>
              <span class="red--text"><strong>* </strong></span
              >{{ barcodeField.label }}
            </template>
          </v-text-field>
        </v-col>
        <v-col v-if="licensePlateField.required" cols="12">
          <v-text-field
            v-model="models[licensePlateField.id]"
            :rules="rules[licensePlateField.id]"
            validate-on-blur
            required
            :loading="validatingLicensePlateLoader"
            @blur="validateLicensePlate()"
            :success-messages="validatingLicensePlateSuccessMessage"
            :error-messages="validatingLicensePlateErrorMessage"
            :messages="validatingLicensePlateLoadingMessage"
            :append-icon="validatingLicensePlateLoadingIcon"
          >
            <template #label>
              <span class="red--text"><strong>* </strong></span
              >{{ licensePlateField.label }}
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="12">
          <v-text-field
            v-model="models[emailField.id]"
            :rules="rules[emailField.id]"
            :type="emailField.type"
            validate-on-blur
            required
            :loading="validatingEmailLoader"
            @blur="validateEmail()"
            :success-messages="validatingEmailSuccessMessage"
            :error-messages="validatingEmailErrorMessage"
            :messages="validatingEmailLoadingMessage"
            :append-icon="validatingEmailLoadingIcon"
          >
            <template #label>
              <span class="red--text"><strong>* </strong></span
              >{{ emailField.label }}
            </template>
          </v-text-field>
        </v-col>

        <v-col v-if="!isFacebookRegister()" cols="12">
          <v-text-field
            v-model="models[passwordField.id]"
            :rules="rules[passwordField.id]"
            :type="passwordField.showPassword ? 'text' : 'password'"
            :label="passwordField.label"
            :append-icon="
              passwordField.showPassword ? 'mdi-eye' : 'mdi-eye-off'
            "
            @click:append="
              passwordField.showPassword = !passwordField.showPassword
            "
            validate-on-blur
            required
          >
            <template #label>
              <span class="red--text"><strong>* </strong></span
              >{{ passwordField.label }}
            </template>
          </v-text-field>
        </v-col>
        <v-col v-if="!isFacebookRegister()" cols="12">
          <v-text-field
            v-model="models[verifyPasswordField.id]"
            :rules="rules[verifyPasswordField.rulesetId]"
            :type="verifyPasswordField.showPassword ? 'text' : 'password'"
            :label="verifyPasswordField.label"
            :append-icon="
              verifyPasswordField.showPassword ? 'mdi-eye' : 'mdi-eye-off'
            "
            @click:append="
              verifyPasswordField.showPassword = !verifyPasswordField.showPassword
            "
            :error="models[verifyPasswordField.id] !== models[passwordField.id]"
            :error-messages="
              models[verifyPasswordField.id] !== models[passwordField.id]
                ? $t('rules.repeated_password_should_be_equal')
                : null
            "
            validate-on-blur
            required
          >
            <template #label>
              <span class="red--text"><strong>* </strong></span
              >{{ verifyPasswordField.label }}
            </template>
          </v-text-field>
        </v-col>
        <v-col
          v-if="licensePlateField.id && !licensePlateField.required"
          cols="12"
        >
          <v-text-field
            v-model="models[licensePlateField.id]"
            :label="licensePlateField.label"
            validate-on-blur
            :loading="validatingLicensePlateLoader"
            @blur="validateLicensePlate()"
            :success-messages="validatingLicensePlateSuccessMessage"
            :error-messages="validatingLicensePlateErrorMessage"
            :messages="validatingLicensePlateLoadingMessage"
            :append-icon="validatingLicensePlateLoadingIcon"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-divider class="pa-3" />
      <v-row>
        <template v-if="!fieldEqualsDisplay('full_name', 'hidden')">
          <v-col
            :key="field.id"
            v-for="field in possibleNameFields"
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="models[field.id]"
              :rules="
                fieldEqualsDisplay('full_name', 'required')
                  ? rules[field.id]
                  : []
              "
              type="text"
              :label="$t(field.label)"
              validate-on-blur
              required
            >
              <template
                v-if="fieldEqualsDisplay('full_name', 'required')"
                #label
              >
                <span class="red--text"><strong>* </strong></span
                >{{ $t(field.label) }}
              </template>
            </v-text-field></v-col
          >
        </template>
        <v-col v-for="field in visibleTextFields" :key="field.id" cols="12">
          <v-text-field
            v-model="models[field.id]"
            :rules="
              fieldEqualsDisplay(field.id, 'required') ? rules[field.id] : []
            "
            :type="field.type"
            :label="$t(field.label)"
            validate-on-blur
            required
          >
            <template v-if="fieldEqualsDisplay(field.id, 'required')" #label>
              <span class="red--text"><strong>* </strong></span
              >{{ $t(field.label) }}
            </template>
          </v-text-field>
        </v-col>
        <template v-if="!fieldEqualsDisplay('address', 'hidden')">
          <v-col
            v-for="field in possibleAddressFields"
            :key="field.id"
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="models[field.id]"
              :rules="
                fieldEqualsDisplay('address', 'required')
                  ? rules['address']
                  : []
              "
              type="text"
              :label="$t(field.label)"
              validate-on-blur
              required
            >
              <template v-if="fieldEqualsDisplay('address', 'required')" #label>
                <span class="red--text"><strong>* </strong></span
                >{{ $t(field.label) }}
              </template>
            </v-text-field></v-col
          >
        </template>
      </v-row>
      <v-divider
        v-if="
          fieldEqualsDisplay(possibleGenderField.id, 'hidden') ||
            fieldEqualsDisplay(possibleDateField.id, 'hidden')
        "
        class="pa-3"
      />
      <v-row>
        <v-col v-if="!fieldEqualsDisplay(possibleGenderField.id, 'hidden')">
          <v-radio-group
            v-model="models.gender"
            row
            :rules="
              fieldEqualsDisplay(possibleGenderField.id, 'required')
                ? rules[possibleGenderField.id]
                : []
            "
          >
            <v-radio
              v-for="choice in possibleGenderField.choices"
              :key="choice.value"
              :value="choice.value"
              :label="$t(choice.label)"
              color="primary"
            ></v-radio>
            <template
              v-if="fieldEqualsDisplay(possibleGenderField.id, 'required')"
              #prepend
            >
              <span class="red--text"><strong>* </strong></span>
            </template>
          </v-radio-group>
        </v-col>
        <v-col v-if="!fieldEqualsDisplay(possibleDateField.id, 'hidden')">
          <v-text-field
            v-model="models[possibleDateField.id]"
            v-mask="possibleDateField.mask"
            placeholder="DD-MM-YYYY"
            :rules="
              fieldEqualsDisplay(possibleDateField.id, 'required')
                ? rules[possibleDateField.id]
                : rules['optional_birth_date']
            "
            validate-on-blur
          >
            <template #label>
              <span
                v-if="fieldEqualsDisplay(possibleDateField.id, 'required')"
                class="red--text"
                ><strong>* </strong></span
              >
              {{ $t(possibleDateField.label) }}
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-divider v-if="visibleCheckFields.length > 0" class="pa-3" />
      <v-row>
        <v-col
          v-for="field in visibleCheckFields"
          :key="field.id"
          cols="12"
          md="6"
        >
          <v-checkbox
            v-model="models[field.id]"
            color="primary"
            validate-on-blur
            :error="
              fieldEqualsDisplay(field.id, 'required') &&
                (models[field.id] === false || models[field.id] === null)
            "
            required
          >
            <template #label>
              {{ $t(field.label)
              }}<span
                v-if="fieldEqualsDisplay(field.id, 'required')"
                class="red--text"
                ><strong>* </strong></span
              >
            </template></v-checkbox
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            text
            color="primary"
            class="no-text-transform"
            @click="goBack()"
            >{{ this.$t("button.back") }}
          </v-btn>
          <v-btn
            color="primary"
            class="no-text-transform display-1"
            type="submit"
            :disabled="!formValid || loading"
            @click="register"
            >{{ this.$t("button.register") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-dialog v-model="loadingShow" width="400" persistent>
      <v-card>
        <div class="pa-10">
          <h3 class="text-center mb-10">
            {{ loadingTitle }}
          </h3>
          <v-row class="justify-center">
            <v-progress-circular
              v-if="loadingStatus === 'busy'"
              :size="150"
              :width="6"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <v-slide-y-transition>
              <v-icon
                size="150"
                color="primary"
                v-if="loadingStatus === 'succeeded'"
                >mdi-check
              </v-icon>
              <v-icon size="150" color="error" v-if="loadingStatus === 'failed'"
                >mdi-alert-circle-outline
              </v-icon>
            </v-slide-y-transition>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mask } from "vue-the-mask";
import { registration } from "../../../../../../mixins/registration";

export default {
  name: "Form",
  directives: {
    mask
  },
  mixins: [registration],
  methods: {
    goBack: function() {
      if (!this.$store.getters["config/hasRegistrationChoice"]) {
        this.$router.go(-1);
        return;
      }
      this.$store.commit("config/resetRegistrationChoice");
    }
  }
};
</script>

<style scoped></style>
